import { http } from '@/services'

export const inventoryService = {
    getInventory: (id) => {
        let url = 'inventory';
        if (id) url += '/' + id;

        return http.get(url)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    setInventory: (item) => {
        return http.post('inventory/' + item.id, item)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    deleteInventory: (item) => {
        return http.delete('inventory/' + item.id)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getInventoryMap: () => {
        return http.get('inventory/map')
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    }
}